import axios from '../../../boot/axios';
import { buildFetchUrl } from "../../../helpers/url";

export default {
    me({dispatch, commit}) {
        return new Promise((resolve, reject) =>
            axios.get('api/v1/users/me').then(({data: r}) => {
                if (r.data) {
                    commit('SET_LOGGED_IN', true);
                    commit('SET_LOGGED_IN_USER', r.data);
                    /** store data in localStorage to show while loading user info */
                    localStorage.setItem('userInfo', JSON.stringify(r.data));
                    if (r.data.mylang)
                        localStorage.setItem('lang', r.data.mylang);
                    else
                        localStorage.setItem('lang', 'en');
                    console.log('===============lang set')
                }

                resolve(r);
            }).catch(({response: {data: err, status}}) => {
                if (status === 401) {
                    dispatch('forceLogout');
                }

                reject(err);
            }));
    },
    updateProfile({commit}, params) {
        return new Promise((resolve, reject) =>
            axios.post('api/v1/users/me/profile', params).then(({data: r}) => {
                if (r.data) {
                    commit('SET_LOGGED_IN_USER', r.data);
                }

                resolve(r);
            }).catch(({response: {data: err}}) => {
                reject(err);
            }));
    },
    getSubscribedUsers({commit}, params) {
        return new Promise((resolve, reject) =>
            axios.post('api/v1/subscribed-list', params)
                .then(({data: r}) => (
                    resolve(r)
                ))
                .catch(({response: {data: err}}) => reject(err)));
    },
    checkAliasIfDuplicate(_, params) {
        return new Promise((resolve, reject) => 
            axios.post('api/v1/user/check-alias', params)
            .then(({data: r}) => {
                resolve(r);
            })
            .catch(({response: {data: err}}) => {
                reject(err);
            }));
    },
    sendUserId(_, params) {
        return new Promise((resolve, reject) => 
            axios.post('api/v1/user/sendUserId', params)
            .then(({data: r}) => {
                resolve(r);
            })
            .catch(({response: {data: err}}) => {
                reject(err);
            }));
    },
    postAlertSet(_, params) {
        return new Promise((resolve, reject) => 
            axios.post('api/v1/user/postAlertSet', params)
            .then(({data: r}) => {
                resolve(r);
            })
            .catch(({response: {data: err}}) => {
                reject(err);
            }));
    },
    getAlertSet(_, params) {
        return new Promise((resolve, reject) => 
            axios.get('api/v1/user/getAlertSet', params)
            .then(({data: r}) => {
                resolve(r);
            })
            .catch(({response: {data: err}}) => {
                reject(err);
            }));
    },
    getUsers(_, params) {
        return new Promise((resolve, reject) => 
            axios.get('api/v1/user/getUsers', params)
            .then(({data: r}) => {
                resolve(r);
            })
            .catch(({response: {data: err}}) => {
                reject(err);
            }));
    },
    saveSubscriptionGroup(_, params) {
        return new Promise((resolve, reject) => 
            axios.post('api/v1/user/saveSubscriptionGroup', params)
            .then(({data: r}) => {
                resolve(r);
            })
            .catch(({response: {data: err}}) => {
                reject(err);
            }));
    },

    getSubscriptionGroups() {
        return new Promise((resolve, reject) =>
            axios.get('api/v1/user/getSubscriptionGroups')
                .then(({data: r}) => (
                    resolve(r)
                ))
                .catch(({response: {data: err}}) => reject(err)));
    },

    updateSubscriptionGroup(_, params) {
        return new Promise((resolve, reject) => 
            axios.post('api/v1/user/updateSubscriptionGroup', params)
            .then(({data: r}) => {
                resolve(r);
            })
            .catch(({response: {data: err}}) => {
                reject(err);
            }));
    },

    deleteSubscriptionGroup(_, params) {
        return new Promise((resolve, reject) => 
            axios.post('api/v1/user/deleteSubscriptionGroup', params)
            .then(({data: r}) => {
                resolve(r);
            })
            .catch(({response: {data: err}}) => {
                reject(err);
            }));
    },

    membership_ids() {
        return new Promise((resolve, reject) => 
            axios.post('api/v1/user/membership_ids')
            .then(({data: r}) => {
                resolve(r);
            })
            .catch(({response: {data: err}}) => {
                reject(err);
            }));
    },

    user_login(_, params) {
        return new Promise((resolve, reject) => 
            axios.post('api/v1/user/login', params)
            .then(({data: r}) => {
                resolve(r);
            })
            .catch(({response: {data: err}}) => {
                reject(err);
            }));
    },

    getSubscriptionURL(_, params) {
        return new Promise((resolve, reject) => 
            axios.post('api/v1/user/getSubscriptionURL', params)
            .then(({data: r}) => {
                resolve(r);
            })
            .catch(({response: {data: err}}) => {
                reject(err);
            }));
    },
}